import { Observable } from '@logz-pkg/observable';

class PlaygroundStateService {
  readonly isPlayground = new Observable<boolean>(false);

  setPlaygroundModalOpen = this.isPlayground.set;
}

export const playgroundStateService = new PlaygroundStateService();
